export { ExcelIconSVG, PDFIconSVG, ExportIconSVG } from "./ExportIcons";

export const BreadcrumbNavigatorSVG = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1138_35318"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect width={16} height={16} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1138_35318)">
      <path
        d="M6.38337 8L3.33337 4.93333L4.26671 4L8.26671 8L4.26671 12L3.33337 11.0667L6.38337 8ZM10.7834 8L7.73337 4.93333L8.66671 4L12.6667 8L8.66671 12L7.73337 11.0667L10.7834 8Z"
        fill="#BDBDBD"
      />
    </g>
  </svg>
);

export const DropdownButtonChevronDown = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1138_25558"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1138_25558)">
      <path
        d="M9 11.55L4.5 7.05L5.55 6L9 9.45L12.45 6L13.5 7.05L9 11.55Z"
        fill={props.fill || "white"}
      />
    </g>
  </svg>
);

export const DropdownButtonChevronUp = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1138_29899"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1138_29899)">
      <path
        d="M9 8.1L5.55 11.55L4.5 10.5L9 6L13.5 10.5L12.45 11.55L9 8.1Z"
        fill={props.fill || "#FCFCFC"}
      />
    </g>
  </svg>
);

export const CalendarChevronLeftSVG = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.676 5.29289C16.0665 5.68342 16.0665 6.31658 15.676 6.70711L10.3831 12L15.676 17.2929C16.0665 17.6834 16.0665 18.3166 15.676 18.7071C15.2855 19.0976 14.6523 19.0976 14.2618 18.7071L8.36783 12.8132C7.91873 12.3641 7.91872 11.6359 8.36783 11.1868L14.2618 5.29289C14.6523 4.90237 15.2855 4.90237 15.676 5.29289Z"
      fill="#CCCCCC"
    />
  </svg>
);

export const CalendarChevronRightSVG = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.3239 18.7071C7.93337 18.3166 7.93337 17.6834 8.3239 17.2929L13.6168 12L8.3239 6.7071C7.93337 6.31658 7.93337 5.68342 8.3239 5.29289C8.71442 4.90237 9.34759 4.90237 9.73811 5.29289L15.632 11.1868C16.0811 11.6359 16.0812 12.3641 15.632 12.8132L9.73811 18.7071C9.34759 19.0976 8.71442 19.0976 8.3239 18.7071Z"
      fill="#CCCCCC"
    />
  </svg>
);

export const TrashSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1138_25436"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1138_25436)">
      <path
        d="M5.25 15.75C4.8375 15.75 4.48438 15.6031 4.19062 15.3094C3.89687 15.0156 3.75 14.6625 3.75 14.25V4.5H3V3H6.75V2.25H11.25V3H15V4.5H14.25V14.25C14.25 14.6625 14.1031 15.0156 13.8094 15.3094C13.5156 15.6031 13.1625 15.75 12.75 15.75H5.25ZM6.75 12.75H8.25V6H6.75V12.75ZM9.75 12.75H11.25V6H9.75V12.75Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const ClockInCheckboxCheckedSVG = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1038_18051"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <rect width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1038_18051)">
      <path
        d="M8.83333 13.5L14.7083 7.625L13.5417 6.45833L8.83333 11.1667L6.45833 8.79167L5.29167 9.95833L8.83333 13.5ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667Z"
        fill="#73B5C5"
      />
    </g>
  </svg>
);

export const ClockInCheckboxUncheckedSVG = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1038_32765"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <rect width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1038_32765)">
      <path
        d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM4.16667 15.8333H15.8333V4.16667H4.16667V15.8333Z"
        fill="#616161"
      />
    </g>
  </svg>
);

export const VerticalDividerSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={2}
    height={50}
    viewBox="0 0 2 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={2} height={50} rx={1} fill="#F5F5F5" />
  </svg>
);

export const ClockOutSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={19}
    height={18}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1038_31651"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={19}
      height={18}
    >
      <rect x={0.5} width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1038_31651)">
      <path
        d="M15.3498 16.95L13.5498 15.15C12.9498 15.5875 12.3029 15.9219 11.6092 16.1531C10.9154 16.3844 10.2123 16.5 9.49981 16.5C8.57481 16.5 7.70293 16.3219 6.88418 15.9656C6.06543 15.6094 5.34981 15.125 4.73731 14.5125C4.1248 13.9 3.64043 13.1844 3.28418 12.3656C2.92793 11.5469 2.7498 10.675 2.7498 9.75C2.7498 9 2.86543 8.27813 3.09668 7.58438C3.32793 6.89062 3.6623 6.2625 4.0998 5.7L1.5498 3.15L2.5998 2.1L16.3998 15.9L15.3498 16.95ZM7.24981 2.25V0.75H11.7498V2.25H7.24981ZM15.4623 12.8625L10.2498 7.65V6H8.7498V6.15L6.36856 3.76875C6.84356 3.51875 7.34668 3.32812 7.87793 3.19688C8.40918 3.06562 8.94981 3 9.49981 3C10.2498 3 10.9842 3.125 11.7029 3.375C12.4217 3.625 13.0998 3.9875 13.7373 4.4625L14.7873 3.4125L15.8373 4.4625L14.7873 5.5125C15.2623 6.15 15.6248 6.82812 15.8748 7.54688C16.1248 8.26562 16.2498 9 16.2498 9.75C16.2498 10.275 16.1842 10.7969 16.0529 11.3156C15.9217 11.8344 15.7248 12.35 15.4623 12.8625Z"
        fill="black"
      />
    </g>
  </svg>
);

export const ClockInSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1038_38529"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1038_38529)">
      <path
        d="M6.75 2.25V0.75H11.25V2.25H6.75ZM8.25 10.5H9.75V6H8.25V10.5ZM9 16.5C8.075 16.5 7.20312 16.3219 6.38438 15.9656C5.56563 15.6094 4.85 15.125 4.2375 14.5125C3.625 13.9 3.14062 13.1844 2.78438 12.3656C2.42813 11.5469 2.25 10.675 2.25 9.75C2.25 8.825 2.42813 7.95312 2.78438 7.13437C3.14062 6.31562 3.625 5.6 4.2375 4.9875C4.85 4.375 5.56563 3.89062 6.38438 3.53438C7.20312 3.17813 8.075 3 9 3C9.775 3 10.5188 3.125 11.2313 3.375C11.9438 3.625 12.6125 3.9875 13.2375 4.4625L14.2875 3.4125L15.3375 4.4625L14.2875 5.5125C14.7625 6.1375 15.125 6.80625 15.375 7.51875C15.625 8.23125 15.75 8.975 15.75 9.75C15.75 10.675 15.5719 11.5469 15.2156 12.3656C14.8594 13.1844 14.375 13.9 13.7625 14.5125C13.15 15.125 12.4344 15.6094 11.6156 15.9656C10.7969 16.3219 9.925 16.5 9 16.5Z"
        fill="white"
      />
    </g>
  </svg>
);

export const InputPasswordShowSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_932_12016"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_932_12016)">
      <path
        d="M9 12C9.9375 12 10.7344 11.6719 11.3906 11.0156C12.0469 10.3594 12.375 9.5625 12.375 8.625C12.375 7.6875 12.0469 6.89062 11.3906 6.23438C10.7344 5.57812 9.9375 5.25 9 5.25C8.0625 5.25 7.26562 5.57812 6.60938 6.23438C5.95312 6.89062 5.625 7.6875 5.625 8.625C5.625 9.5625 5.95312 10.3594 6.60938 11.0156C7.26562 11.6719 8.0625 12 9 12ZM9 10.65C8.4375 10.65 7.95938 10.4531 7.56563 10.0594C7.17188 9.66563 6.975 9.1875 6.975 8.625C6.975 8.0625 7.17188 7.58437 7.56563 7.19063C7.95938 6.79688 8.4375 6.6 9 6.6C9.5625 6.6 10.0406 6.79688 10.4344 7.19063C10.8281 7.58437 11.025 8.0625 11.025 8.625C11.025 9.1875 10.8281 9.66563 10.4344 10.0594C10.0406 10.4531 9.5625 10.65 9 10.65ZM9 14.25C7.175 14.25 5.5125 13.7406 4.0125 12.7219C2.5125 11.7031 1.425 10.3375 0.75 8.625C1.425 6.9125 2.5125 5.54688 4.0125 4.52813C5.5125 3.50938 7.175 3 9 3C10.825 3 12.4875 3.50938 13.9875 4.52813C15.4875 5.54688 16.575 6.9125 17.25 8.625C16.575 10.3375 15.4875 11.7031 13.9875 12.7219C12.4875 13.7406 10.825 14.25 9 14.25ZM9 12.75C10.4125 12.75 11.7094 12.3781 12.8906 11.6344C14.0719 10.8906 14.975 9.8875 15.6 8.625C14.975 7.3625 14.0719 6.35938 12.8906 5.61562C11.7094 4.87187 10.4125 4.5 9 4.5C7.5875 4.5 6.29063 4.87187 5.10938 5.61562C3.92812 6.35938 3.025 7.3625 2.4 8.625C3.025 9.8875 3.92812 10.8906 5.10938 11.6344C6.29063 12.3781 7.5875 12.75 9 12.75Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const InputPasswordHideSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_932_20317"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_932_20317)">
      <path
        d="M12.075 9.97559L10.9875 8.88809C11.1 8.30059 10.9313 7.75059 10.4813 7.23809C10.0312 6.72559 9.45 6.52559 8.7375 6.63809L7.65 5.55059C7.8625 5.45059 8.07812 5.37559 8.29688 5.32559C8.51562 5.27559 8.75 5.25059 9 5.25059C9.9375 5.25059 10.7344 5.57871 11.3906 6.23496C12.0469 6.89121 12.375 7.68809 12.375 8.62559C12.375 8.87559 12.35 9.10996 12.3 9.32871C12.25 9.54746 12.175 9.76309 12.075 9.97559ZM14.475 12.3381L13.3875 11.2881C13.8625 10.9256 14.2844 10.5287 14.6531 10.0975C15.0219 9.66621 15.3375 9.17559 15.6 8.62559C14.975 7.36309 14.0781 6.35996 12.9094 5.61621C11.7406 4.87246 10.4375 4.50059 9 4.50059C8.6375 4.50059 8.28125 4.52559 7.93125 4.57559C7.58125 4.62559 7.2375 4.70059 6.9 4.80059L5.7375 3.63809C6.25 3.42559 6.775 3.26621 7.3125 3.15996C7.85 3.05371 8.4125 3.00059 9 3.00059C10.8875 3.00059 12.5688 3.52246 14.0438 4.56621C15.5188 5.60996 16.5875 6.96309 17.25 8.62559C16.9625 9.36309 16.5844 10.0475 16.1156 10.6787C15.6469 11.31 15.1 11.8631 14.475 12.3381ZM14.85 16.9506L11.7 13.8381C11.2625 13.9756 10.8219 14.0787 10.3781 14.1475C9.93438 14.2162 9.475 14.2506 9 14.2506C7.1125 14.2506 5.43125 13.7287 3.95625 12.685C2.48125 11.6412 1.4125 10.2881 0.75 8.62559C1.0125 7.96309 1.34375 7.34746 1.74375 6.77871C2.14375 6.20996 2.6 5.70059 3.1125 5.25059L1.05 3.15059L2.1 2.10059L15.9 15.9006L14.85 16.9506ZM4.1625 6.30059C3.8 6.62559 3.46875 6.98184 3.16875 7.36934C2.86875 7.75684 2.6125 8.17559 2.4 8.62559C3.025 9.88809 3.92188 10.8912 5.09062 11.635C6.25938 12.3787 7.5625 12.7506 9 12.7506C9.25 12.7506 9.49375 12.735 9.73125 12.7037C9.96875 12.6725 10.2125 12.6381 10.4625 12.6006L9.7875 11.8881C9.65 11.9256 9.51875 11.9537 9.39375 11.9725C9.26875 11.9912 9.1375 12.0006 9 12.0006C8.0625 12.0006 7.26562 11.6725 6.60938 11.0162C5.95312 10.36 5.625 9.56309 5.625 8.62559C5.625 8.48809 5.63438 8.35684 5.65312 8.23184C5.67188 8.10684 5.7 7.97559 5.7375 7.83809L4.1625 6.30059Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const InputSearchIconSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
      stroke="#7E7E7E"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.7503 15.7508L12.4878 12.4883"
      stroke="#7E7E7E"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIconSVG = ({
  color = "white",
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.25 9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75H9.75V14.25H8.25V9.75Z"
      fill={color}
    />
  </svg>
);

export const AuthGoBackSVG = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_739_21502"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={18}
        height={18}
      >
        <rect width={18} height={18} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_739_21502)">
        <path
          d="M10.5 13.5L6 9L10.5 4.5L11.55 5.55L8.1 9L11.55 12.45L10.5 13.5Z"
          fill="#6C6C6C"
        />
      </g>
    </svg>
  );
};

export const ProjectSVG = ({
  active = false,
  ...props
}: React.SVGProps<SVGSVGElement> & { active?: boolean }) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_739_885)">
        <path
          d="M17.4219 2.97074V7.26562C17.4219 7.48137 17.247 7.65625 17.0312 7.65625H8.82812C8.61238 7.65625 8.4375 7.48137 8.4375 7.26562V2.96875H2.65625C1.53621 2.96875 0.625 3.87996 0.625 5V13.125H19.375V5C19.375 3.90617 18.5058 3.01199 17.4219 2.97074ZM7.65625 11.1719C7.65625 11.3876 7.48137 11.5625 7.26562 11.5625H2.57812C2.36238 11.5625 2.1875 11.3876 2.1875 11.1719V5.3125C2.1875 5.09676 2.36238 4.92188 2.57812 4.92188H5.85938C5.96297 4.92188 6.06234 4.96305 6.13559 5.03629L7.54184 6.44254C7.61508 6.51582 7.65625 6.61516 7.65625 6.71875V11.1719ZM17.0312 11.5625H9.60938C9.39363 11.5625 9.21875 11.3876 9.21875 11.1719C9.21875 10.9562 9.39363 10.7812 9.60938 10.7812H17.0312C17.247 10.7812 17.4219 10.9562 17.4219 11.1719C17.4219 11.3876 17.247 11.5625 17.0312 11.5625ZM17.0312 10H9.60938C9.39363 10 9.21875 9.82512 9.21875 9.60938C9.21875 9.39363 9.39363 9.21875 9.60938 9.21875H17.0312C17.247 9.21875 17.4219 9.39363 17.4219 9.60938C17.4219 9.82512 17.247 10 17.0312 10Z"
          fill={active ? "#73B5C5" : "#6C6C6C"}
        />
        <path
          d="M2.96875 5.70312V10.7812H6.875V6.88055L5.69758 5.70312H2.96875ZM4.14062 7.26562H4.92188C5.13762 7.26562 5.3125 7.44051 5.3125 7.65625C5.3125 7.87199 5.13762 8.04688 4.92188 8.04688H4.14062C3.92488 8.04688 3.75 7.87199 3.75 7.65625C3.75 7.44051 3.92488 7.26562 4.14062 7.26562ZM6.09375 9.21875C6.09375 9.43449 5.91887 9.60938 5.70312 9.60938H4.14062C3.92488 9.60938 3.75 9.43449 3.75 9.21875C3.75 9.00301 3.92488 8.82812 4.14062 8.82812H5.70312C5.91887 8.82812 6.09375 9.00301 6.09375 9.21875Z"
          fill={active ? "#73B5C5" : "#6C6C6C"}
        />
        <path
          d="M0.625 15C0.625 16.12 1.53621 17.0312 2.65625 17.0312H8.4375V17.4219C8.4375 18.068 7.9118 18.5938 7.26562 18.5938C7.04988 18.5938 6.875 18.7687 6.875 18.9844C6.875 19.2001 7.04988 19.375 7.26562 19.375H12.7344C12.9501 19.375 13.125 19.2001 13.125 18.9844C13.125 18.7687 12.9501 18.5938 12.7344 18.5938C12.0882 18.5938 11.5625 18.068 11.5625 17.4219V17.0312H17.3438C18.4638 17.0312 19.375 16.12 19.375 15V13.9062H0.625V15ZM9.80469 15.0781H10.1953C10.4111 15.0781 10.5859 15.253 10.5859 15.4688C10.5859 15.6845 10.4111 15.8594 10.1953 15.8594H9.80469C9.58895 15.8594 9.41406 15.6845 9.41406 15.4688C9.41406 15.253 9.58895 15.0781 9.80469 15.0781Z"
          fill={active ? "#73B5C5" : "#6C6C6C"}
        />
        <path
          d="M16.6406 0.917969C16.6406 0.756172 16.5095 0.625 16.3477 0.625H9.51172C9.34992 0.625 9.21875 0.756172 9.21875 0.917969V2.1875H16.6406V0.917969Z"
          fill={active ? "#73B5C5" : "#6C6C6C"}
        />
        <path
          d="M9.51172 6.875H16.3477C16.5095 6.875 16.6406 6.74383 16.6406 6.58203V2.96875H9.21875V6.58203C9.21875 6.74383 9.34992 6.875 9.51172 6.875ZM10.3906 3.75H13.5156C13.7313 3.75 13.9062 3.92488 13.9062 4.14062C13.9062 4.35637 13.7313 4.53125 13.5156 4.53125H10.3906C10.1749 4.53125 10 4.35637 10 4.14062C10 3.92488 10.1749 3.75 10.3906 3.75ZM10.3906 5.3125H15.4688C15.6845 5.3125 15.8594 5.48738 15.8594 5.70312C15.8594 5.91887 15.6845 6.09375 15.4688 6.09375H10.3906C10.1749 6.09375 10 5.91887 10 5.70312C10 5.48738 10.1749 5.3125 10.3906 5.3125Z"
          fill={active ? "#73B5C5" : "#6C6C6C"}
        />
      </g>
      <defs>
        <clipPath id="clip0_739_885">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ClientSVG = ({
  active,
  ...props
}: React.SVGProps<SVGSVGElement> & { active?: boolean }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.07491 10.3034C5.38644 10.286 5.69281 10.2163 5.98116 10.0971C5.69292 10.0451 5.4326 9.89225 5.24679 9.66585C5.16875 9.5551 5.11717 9.42791 5.09604 9.29409C5.07491 9.16026 5.08479 9.02338 5.12491 8.89397L5.54991 7.47522C5.71168 6.90467 6.22729 6.70603 6.74681 6.57525L6.34991 6.45024C6.1855 6.62352 5.98753 6.76152 5.76806 6.85582C5.54859 6.95013 5.31221 6.99876 5.07334 6.99875C4.83447 6.99875 4.5981 6.95011 4.37863 6.8558C4.15916 6.76149 3.9612 6.62349 3.79679 6.4502L2.40304 6.88149C2.2809 6.9202 2.16993 6.98788 2.0796 7.07875C1.98928 7.16962 1.92227 7.28099 1.88429 7.40336L1.50616 8.65961C1.46511 8.7972 1.47937 8.94537 1.5459 9.0726C1.61244 9.19983 1.726 9.29608 1.86241 9.34086C2.25453 9.4395 4.71237 10.3593 5.07491 10.3034Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
    <path
      d="M6.25002 7.07519C6.05702 7.17938 5.91319 7.3558 5.85001 7.56582L5.42189 8.98769C5.37808 9.13233 5.39243 9.28836 5.46187 9.42259C5.53132 9.55681 5.65039 9.65865 5.79377 9.70644L6.48127 9.93145C6.92509 10.0464 8.98411 10.8406 9.41564 10.7971C9.8371 10.8438 11.9181 10.0421 12.35 9.93148L13.0375 9.70644C13.179 9.65811 13.2963 9.55701 13.365 9.42426C13.4337 9.2915 13.4485 9.13734 13.4063 8.99395L12.9781 7.56894C12.9381 7.43568 12.8659 7.31434 12.7677 7.21568C12.6696 7.11701 12.5487 7.04407 12.4156 7.00332C12.0195 6.88334 11.2235 6.63304 10.8313 6.5127C10.8022 6.50439 10.7754 6.48941 10.7531 6.46895C10.6015 6.61624 10.4274 6.73859 10.2375 6.83145C9.98156 6.95864 9.69953 7.02457 9.41371 7.02402C9.12789 7.02348 8.84611 6.95648 8.59064 6.82832C8.40168 6.7354 8.22869 6.61304 8.07814 6.46582C8.05488 6.48958 8.02578 6.50682 7.99377 6.51582C7.52896 6.67539 6.70143 6.88113 6.25002 7.07519Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
    <path
      d="M8.20942 6.14375C9.65345 7.64416 11.398 5.92931 11.3187 4.20621C11.3188 2.825 10.4657 1.70312 9.41567 1.70312C7.53771 1.72013 6.90713 4.823 8.20942 6.14375Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
    <path
      d="M4.49679 6.55918C5.80108 7.13324 6.82503 5.72133 6.7905 4.44357C6.79054 3.20293 6.02179 2.19043 5.07491 2.19043C3.13217 2.22447 2.72488 5.7391 4.49679 6.55918Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
    <path
      d="M14.5 6.83457C14.1661 6.99222 13.7909 7.03995 13.4281 6.97088C13.0654 6.90182 12.7339 6.71952 12.4813 6.4502L12.0813 6.5752C12.6055 6.70627 13.1215 6.90548 13.2782 7.48148L13.7032 8.90332C13.7695 9.12381 13.7475 9.36142 13.642 9.56605C13.5365 9.77068 13.3556 9.92634 13.1375 10.0002L12.85 10.0971L13.2219 10.2189C13.5704 10.3314 13.9454 10.3314 14.2938 10.2189L16.9719 9.34082C17.1061 9.29428 17.2173 9.19793 17.2824 9.0717C17.3476 8.94548 17.3617 8.79905 17.3219 8.6627L16.9407 7.40332C16.9037 7.28044 16.837 7.16856 16.7465 7.07754C16.6561 6.98653 16.5446 6.91918 16.4219 6.88145L15.0344 6.4502C14.879 6.6072 14.6983 6.73711 14.5 6.83457Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
    <path
      d="M13.1813 6.5623C14.4858 7.12819 15.5098 5.72327 15.475 4.44355C15.475 3.20293 14.7063 2.19043 13.7563 2.19043C11.8124 2.2273 11.4134 5.73663 13.1813 6.5623Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
    <path
      d="M17.6752 10.9966H17.1658C17.0566 10.9874 16.9481 11.0216 16.8639 11.0918C16.7797 11.162 16.7265 11.2625 16.7158 11.3716V16.3653C16.7258 16.4749 16.7787 16.5762 16.863 16.647C16.9473 16.7178 17.0561 16.7525 17.1658 16.7435H17.6752C17.7848 16.752 17.8933 16.7171 17.9775 16.6464C18.0617 16.5757 18.1147 16.4747 18.1252 16.3653V11.3747C18.1147 11.2653 18.0617 11.1644 17.9775 11.0936C17.8933 11.0229 17.7848 10.9881 17.6752 10.9966Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
    <path
      d="M13.7031 11.9871L12.7343 12.5308C12.4257 12.7061 12.0842 12.8157 11.7312 12.8527C10.9812 12.9308 9.58747 13.0871 8.71247 13.2371C8.56699 13.2626 8.43519 13.3387 8.3403 13.4519C8.2454 13.565 8.19349 13.7081 8.19372 13.8558C8.18541 13.9748 8.21056 14.0938 8.26634 14.1993C8.32212 14.3048 8.40629 14.3925 8.50935 14.4527L12.9531 13.9746C13.0348 13.9674 13.1159 13.9926 13.1792 14.0447C13.2425 14.0969 13.2827 14.1718 13.2913 14.2533C13.2999 14.3348 13.2762 14.4164 13.2252 14.4806C13.1742 14.5448 13.1 14.5864 13.0187 14.5964L8.48747 15.0839C8.24879 15.0517 8.03227 14.9271 7.88435 14.7371C7.11521 14.924 6.23882 14.9854 5.56249 14.4964L2.61247 12.4839C2.51586 12.4166 2.39674 12.3896 2.28054 12.4089C2.16435 12.4282 2.06029 12.4921 1.9906 12.5871C1.91137 12.6755 1.86994 12.7914 1.8752 12.91C1.88046 13.0286 1.93198 13.1404 2.01872 13.2214L5.29372 16.3152C5.64456 16.6488 6.08983 16.866 6.56872 16.9371L11.1843 17.637C11.767 17.7281 12.3635 17.65 12.9031 17.4121L16.0906 16.0371V11.6839C15.3678 11.7029 14.339 11.5766 13.7031 11.9871Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
  </svg>
);

export const UserManagementSVG = ({
  active,
  ...props
}: React.SVGProps<SVGSVGElement> & { active?: boolean }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_739_2934"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <rect width={20} height={20} fill={active ? "#73B5C5" : "#D9D9D9"} />
    </mask>
    <g mask="url(#mask0_739_2934)">
      <path
        d="M13.3333 17.4997L13.0833 16.2497C12.9166 16.1802 12.7604 16.1073 12.6145 16.0309C12.4687 15.9545 12.3194 15.8608 12.1666 15.7497L10.9583 16.1247L10.125 14.708L11.0833 13.8747C11.0555 13.6802 11.0416 13.4997 11.0416 13.333C11.0416 13.1663 11.0555 12.9858 11.0833 12.7913L10.125 11.958L10.9583 10.5413L12.1666 10.9163C12.3194 10.8052 12.4687 10.7115 12.6145 10.6351C12.7604 10.5587 12.9166 10.4858 13.0833 10.4163L13.3333 9.16634H15L15.25 10.4163C15.4166 10.4858 15.5729 10.5622 15.7187 10.6455C15.8645 10.7288 16.0138 10.833 16.1666 10.958L17.375 10.5413L18.2083 11.9997L17.25 12.833C17.2777 12.9997 17.2916 13.1733 17.2916 13.3538C17.2916 13.5344 17.2777 13.708 17.25 13.8747L18.2083 14.708L17.375 16.1247L16.1666 15.7497C16.0138 15.8608 15.8645 15.9545 15.7187 16.0309C15.5729 16.1073 15.4166 16.1802 15.25 16.2497L15 17.4997H13.3333ZM1.66663 16.6663V14.333C1.66663 13.8747 1.78468 13.4441 2.02079 13.0413C2.2569 12.6386 2.58329 12.333 2.99996 12.1247C3.70829 11.7636 4.5069 11.458 5.39579 11.208C6.28468 10.958 7.26385 10.833 8.33329 10.833H8.62496C8.70829 10.833 8.79163 10.8469 8.87496 10.8747C8.47218 11.8747 8.30552 12.8677 8.37496 13.8538C8.4444 14.84 8.77774 15.7775 9.37496 16.6663H1.66663ZM14.1666 14.9997C14.625 14.9997 15.0173 14.8365 15.3437 14.5101C15.6701 14.1837 15.8333 13.7913 15.8333 13.333C15.8333 12.8747 15.6701 12.4823 15.3437 12.1559C15.0173 11.8295 14.625 11.6663 14.1666 11.6663C13.7083 11.6663 13.3159 11.8295 12.9895 12.1559C12.6632 12.4823 12.5 12.8747 12.5 13.333C12.5 13.7913 12.6632 14.1837 12.9895 14.5101C13.3159 14.8365 13.7083 14.9997 14.1666 14.9997ZM8.33329 9.99967C7.41663 9.99967 6.6319 9.67329 5.97913 9.02051C5.32635 8.36773 4.99996 7.58301 4.99996 6.66634C4.99996 5.74967 5.32635 4.96495 5.97913 4.31217C6.6319 3.6594 7.41663 3.33301 8.33329 3.33301C9.24996 3.33301 10.0347 3.6594 10.6875 4.31217C11.3402 4.96495 11.6666 5.74967 11.6666 6.66634C11.6666 7.58301 11.3402 8.36773 10.6875 9.02051C10.0347 9.67329 9.24996 9.99967 8.33329 9.99967Z"
        fill={active ? "#73B5C5" : "#6C6C6C"}
      />
    </g>
  </svg>
);

export const TimeEntrySVG = ({
  active,
  ...props
}: React.SVGProps<SVGSVGElement> & { active?: boolean }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.52783 9.37325V10.3981H4.22165C4.37932 10.3981 4.51923 10.5167 4.51923 10.6765V10.9798L6.70523 9.88533L4.51923 8.79087V9.09414C4.51923 9.25395 4.37932 9.37254 4.22165 9.37254L1.52783 9.37325ZM3.65001 10.7589H4.15783V11.0984C4.15783 11.3122 4.40072 11.4414 4.59605 11.3434L7.01787 10.1311C7.22667 10.0267 7.22667 9.74613 7.01787 9.64173L4.59605 8.42936C4.40074 8.33135 4.15783 8.46061 4.15783 8.6744V9.01389H3.65001V3.77734H15.042L7.91692 6.02516C7.84093 6.04576 7.78411 6.11607 7.78411 6.19917V15.9968L3.64993 15.9961L3.65001 10.7589ZM17.8106 14.1545C16.9277 13.2717 15.4966 13.2717 14.6138 14.1545C13.731 15.0374 13.731 16.4685 14.6138 17.3513C15.4966 18.2341 16.9278 18.2341 17.8106 17.3513C18.6934 16.4685 18.6934 15.0367 17.8106 14.1545ZM16.0322 13.1375V3.84203L8.14507 6.33003V18.0431L13.7232 16.5765C13.187 14.9558 14.3262 13.254 16.0322 13.1375ZM16.1884 15.2831C16.192 15.2831 16.1955 15.2824 16.1998 15.2824C16.1955 15.2824 16.192 15.2824 16.1884 15.2831ZM16.177 15.2838C16.1806 15.2838 16.1849 15.2831 16.1884 15.2831C16.1841 15.2831 16.1806 15.2831 16.177 15.2838ZM16.1643 15.2845C16.1678 15.2838 16.1721 15.2838 16.1756 15.2838C16.1721 15.2838 16.1678 15.2845 16.1643 15.2845ZM16.1415 15.2874C16.1451 15.2867 16.1479 15.2867 16.1515 15.2859C16.1486 15.2867 16.1451 15.2867 16.1415 15.2874ZM16.6785 15.8136C16.6778 15.8172 16.6778 15.82 16.677 15.8236C16.6778 15.82 16.6785 15.8165 16.6785 15.8136ZM16.6799 15.8009C16.6792 15.8044 16.6792 15.8087 16.6785 15.8122C16.6792 15.8087 16.6799 15.8051 16.6799 15.8009ZM16.6813 15.7895C16.6813 15.7931 16.6806 15.7973 16.6806 15.8009C16.6806 15.7966 16.6813 15.7931 16.6813 15.7895ZM16.682 15.7767C16.682 15.7803 16.6813 15.7845 16.6813 15.7881C16.6813 15.7845 16.682 15.781 16.682 15.7767ZM16.6827 15.7654C16.6827 15.7689 16.6827 15.7725 16.682 15.7767C16.682 15.7725 16.6827 15.7689 16.6827 15.7654ZM16.6806 15.7043C16.6813 15.7078 16.6813 15.7121 16.6813 15.7156C16.6806 15.7121 16.6806 15.7085 16.6806 15.7043ZM16.6792 15.6929C16.6799 15.6965 16.6799 15.7007 16.6806 15.7043C16.6799 15.7007 16.6792 15.6972 16.6792 15.6929ZM16.6778 15.6823C16.6785 15.6858 16.6785 15.6886 16.6792 15.6922C16.6785 15.6886 16.6778 15.6858 16.6778 15.6823ZM16.6756 15.6709C16.6763 15.6737 16.677 15.6773 16.677 15.6801C16.6763 15.6773 16.6763 15.6737 16.6756 15.6709ZM16.3929 15.3179C16.508 15.3655 16.5996 15.4578 16.6472 15.5722H17.589C17.8262 15.5722 17.8262 15.933 17.589 15.933H16.6472C16.5762 16.1034 16.4086 16.2235 16.2125 16.2235C15.9526 16.2235 15.7424 16.0125 15.7424 15.7533C15.7424 15.5573 15.8624 15.3897 16.0329 15.3186V14.6524C16.0329 14.4152 16.3937 14.4152 16.3937 14.6524L16.3929 15.3179ZM16.285 15.2881C16.2878 15.2888 16.2914 15.2888 16.2942 15.2895C16.2914 15.2888 16.2878 15.2881 16.285 15.2881ZM16.2608 15.2845C16.2644 15.2852 16.2687 15.2852 16.2722 15.2859C16.2679 15.2852 16.2644 15.2852 16.2608 15.2845ZM16.2367 15.2831C16.2402 15.2831 16.2445 15.2838 16.2481 15.2838C16.2438 15.2831 16.2402 15.2831 16.2367 15.2831Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
  </svg>
);

export const ReportsSVG = ({
  active,
  ...props
}: React.SVGProps<SVGSVGElement> & { active?: boolean }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13.2 1V4.4H16.6L13.2 1Z" fill={active ? "#73B5C5" : "#6C6C6C"} />
    <path
      d="M16 17.4004H4.19995V18.0004H16V17.4004Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
    <path
      d="M12.6 5V1H3.59998V17H16.6V5H12.6ZM11.4 11.6H5.77998V10.48H11.4V11.6ZM14.22 9.88H5.77998V8.78H14.22V9.88ZM14.22 8.22H5.77998V7.12H14.22V8.22Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
    <path
      d="M15.3999 18.4004H4.79993V19.0004H15.3999V18.4004Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
  </svg>
);

export const AlltimeEntriesSVG = ({
  active,
  ...props
}: React.SVGProps<SVGSVGElement> & { active?: boolean }) => (
  <svg
    width={14}
    height={16}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.59581 14.1166H11.6282V15.5129H0.685913V1.88254H2.37181V13.8943C2.37181 14.0173 2.47286 14.1166 2.59581 14.1166ZM13.3141 0.486328V13.6703H2.81981V0.486328H13.3141ZM5.4657 4.87033C5.4657 5.53559 5.72002 6.20085 6.22697 6.70949C6.73391 7.21812 7.40086 7.47075 8.06612 7.47075C8.73139 7.47075 9.39665 7.21643 9.90528 6.70949C10.4139 6.20085 10.6665 5.53559 10.6665 4.87033C10.6665 4.20507 10.4122 3.5398 9.90528 3.03117C9.39665 2.52254 8.73139 2.26991 8.06612 2.26991C7.40086 2.26991 6.7356 2.52422 6.22697 3.03117C5.71833 3.5398 5.4657 4.20507 5.4657 4.87033ZM11.1449 11.6644C11.1449 11.5415 11.0455 11.4404 10.9209 11.4404H5.2097C5.08675 11.4404 4.9857 11.5398 4.9857 11.6644C4.9857 11.7874 5.08507 11.8884 5.2097 11.8884H10.9209C11.0455 11.8867 11.1449 11.7874 11.1449 11.6644ZM11.1449 10.1806C11.1449 10.0577 11.0455 9.95664 10.9209 9.95664H5.2097C5.08675 9.95664 4.9857 10.056 4.9857 10.1806C4.9857 10.3036 5.08507 10.4046 5.2097 10.4046H10.9209C11.0455 10.4046 11.1449 10.3053 11.1449 10.1806ZM11.1449 8.69854C11.1449 8.57559 11.0455 8.47454 10.9209 8.47454H5.2097C5.08675 8.47454 4.9857 8.57391 4.9857 8.69854C4.9857 8.82149 5.08507 8.92254 5.2097 8.92254H10.9209C11.0455 8.92254 11.1449 8.82149 11.1449 8.69854ZM6.49812 4.87033C6.49812 4.74738 6.39876 4.64633 6.27412 4.64633H5.92381C5.97265 4.17138 6.17981 3.70991 6.5436 3.34612C6.90739 2.98233 7.36886 2.77517 7.84381 2.72633V3.08338C7.84381 3.20633 7.94318 3.30738 8.06781 3.30738C8.19076 3.30738 8.29181 3.20801 8.29181 3.08338V2.72801C8.76675 2.77685 9.22823 2.98401 9.59202 3.3478C9.95581 3.71159 10.163 4.17307 10.2118 4.64801H9.86149C9.73854 4.64801 9.63749 4.74738 9.63749 4.87201C9.63749 4.99496 9.73686 5.09601 9.86149 5.09601H10.2118C10.163 5.57096 9.95581 6.03243 9.59202 6.39622C9.22823 6.76001 8.76675 6.96717 8.29181 7.01601V6.6657C8.29181 6.54275 8.19244 6.4417 8.06781 6.4417C7.94486 6.4417 7.84381 6.54107 7.84381 6.6657V7.01601C7.36886 6.96717 6.90739 6.76001 6.5436 6.39622C6.17981 6.03243 5.97433 5.57096 5.92381 5.09601H6.27412C6.39707 5.09433 6.49812 4.99328 6.49812 4.87033ZM7.84549 4.87033C7.84549 4.99328 7.94486 5.09433 8.06949 5.09433H8.78023C8.90318 5.09433 9.00423 4.99496 9.00423 4.87033C9.00423 4.74738 8.90486 4.64633 8.78023 4.64633H8.29349V3.83454C8.29349 3.71159 8.19412 3.61054 8.06949 3.61054C7.94654 3.61054 7.84549 3.70991 7.84549 3.83454V4.87033Z"
      fill={active ? "#73B5C5" : "#6C6C6C"}
    />
  </svg>
);

export const ProjectTrackingSVG = ({
  active,
  ...props
}: React.SVGProps<SVGSVGElement> & { active?: boolean }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_739_2965"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect width={16} height={16} fill={active ? "#73B5C5" : "#D9D9D9"} />
    </mask>
    <g mask="url(#mask0_739_2965)">
      <path
        d="M5.33333 11.3333C5.52222 11.3333 5.68056 11.2694 5.80833 11.1417C5.93611 11.0139 6 10.8556 6 10.6667C6 10.4778 5.93611 10.3194 5.80833 10.1917C5.68056 10.0639 5.52222 10 5.33333 10C5.14444 10 4.98611 10.0639 4.85833 10.1917C4.73056 10.3194 4.66667 10.4778 4.66667 10.6667C4.66667 10.8556 4.73056 11.0139 4.85833 11.1417C4.98611 11.2694 5.14444 11.3333 5.33333 11.3333ZM5.33333 8.66667C5.52222 8.66667 5.68056 8.60278 5.80833 8.475C5.93611 8.34722 6 8.18889 6 8C6 7.81111 5.93611 7.65278 5.80833 7.525C5.68056 7.39722 5.52222 7.33333 5.33333 7.33333C5.14444 7.33333 4.98611 7.39722 4.85833 7.525C4.73056 7.65278 4.66667 7.81111 4.66667 8C4.66667 8.18889 4.73056 8.34722 4.85833 8.475C4.98611 8.60278 5.14444 8.66667 5.33333 8.66667ZM5.33333 6C5.52222 6 5.68056 5.93611 5.80833 5.80833C5.93611 5.68056 6 5.52222 6 5.33333C6 5.14444 5.93611 4.98611 5.80833 4.85833C5.68056 4.73056 5.52222 4.66667 5.33333 4.66667C5.14444 4.66667 4.98611 4.73056 4.85833 4.85833C4.73056 4.98611 4.66667 5.14444 4.66667 5.33333C4.66667 5.52222 4.73056 5.68056 4.85833 5.80833C4.98611 5.93611 5.14444 6 5.33333 6ZM7.33333 11.3333H11.3333V10H7.33333V11.3333ZM7.33333 8.66667H11.3333V7.33333H7.33333V8.66667ZM7.33333 6H11.3333V4.66667H7.33333V6ZM3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333Z"
        fill={active ? "#73B5C5" : "#6C6C6C"}
      />
    </g>
  </svg>
);

export const UserProfileChevronUpSVG = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 19.1C15.0258 19.1 19.1 15.0258 19.1 10C19.1 4.97421 15.0258 0.9 10 0.9C4.97421 0.9 0.9 4.97421 0.9 10C0.9 15.0258 4.97421 19.1 10 19.1Z"
      stroke="#616161"
      strokeWidth={0.2}
    />
    <mask
      id="mask0_739_2997"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={2}
      width={17}
      height={16}
    >
      <rect x={2.00049} y={2} width={16} height={16} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_739_2997)">
      <path
        d="M10.0005 12.2663L6.00049 8.26634L6.93382 7.33301L10.0005 10.3997L13.0672 7.33301L14.0005 8.26634L10.0005 12.2663Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const UserProfileChevronDownSVG = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 19.1C15.0258 19.1 19.1 15.0258 19.1 10C19.1 4.97421 15.0258 0.9 10 0.9C4.97421 0.9 0.9 4.97421 0.9 10C0.9 15.0258 4.97421 19.1 10 19.1Z"
      stroke="#616161"
      strokeWidth={0.2}
    />
    <mask
      id="mask0_739_10470"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={2}
      y={2}
      width={17}
      height={16}
    >
      <rect x={2.00049} y={2} width={16} height={16} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_739_10470)">
      <path
        d="M10.0005 9.19967L6.93382 12.2663L6.00049 11.333L10.0005 7.33301L14.0005 11.333L13.0672 12.2663L10.0005 9.19967Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const UserProfileSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={38}
    height={38}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.72496 28.3503C9.28329 27.1587 11.025 26.2191 12.95 25.5316C14.875 24.8441 16.8916 24.5003 19 24.5003C21.1083 24.5003 23.125 24.8441 25.05 25.5316C26.975 26.2191 28.7166 27.1587 30.275 28.3503C31.3444 27.0975 32.177 25.6767 32.7729 24.0878C33.3687 22.4989 33.6666 20.8031 33.6666 19.0003C33.6666 14.9364 32.2382 11.476 29.3812 8.61908C26.5243 5.76213 23.0638 4.33366 19 4.33366C14.9361 4.33366 11.4757 5.76213 8.61871 8.61908C5.76177 11.476 4.33329 14.9364 4.33329 19.0003C4.33329 20.8031 4.63121 22.4989 5.22704 24.0878C5.82288 25.6767 6.65552 27.0975 7.72496 28.3503ZM19 20.8337C17.1972 20.8337 15.677 20.2149 14.4395 18.9774C13.202 17.7399 12.5833 16.2198 12.5833 14.417C12.5833 12.6142 13.202 11.0941 14.4395 9.85658C15.677 8.61908 17.1972 8.00033 19 8.00033C20.8027 8.00033 22.3229 8.61908 23.5604 9.85658C24.7979 11.0941 25.4166 12.6142 25.4166 14.417C25.4166 16.2198 24.7979 17.7399 23.5604 18.9774C22.3229 20.2149 20.8027 20.8337 19 20.8337ZM19 37.3337C16.4638 37.3337 14.0805 36.8524 11.85 35.8899C9.6194 34.9274 7.67913 33.6212 6.02913 31.9712C4.37913 30.3212 3.07288 28.3809 2.11038 26.1503C1.14788 23.9198 0.666626 21.5364 0.666626 19.0003C0.666626 16.4642 1.14788 14.0809 2.11038 11.8503C3.07288 9.61977 4.37913 7.67949 6.02913 6.02949C7.67913 4.37949 9.6194 3.07324 11.85 2.11074C14.0805 1.14824 16.4638 0.666992 19 0.666992C21.5361 0.666992 23.9194 1.14824 26.15 2.11074C28.3805 3.07324 30.3208 4.37949 31.9708 6.02949C33.6208 7.67949 34.927 9.61977 35.8895 11.8503C36.852 14.0809 37.3333 16.4642 37.3333 19.0003C37.3333 21.5364 36.852 23.9198 35.8895 26.1503C34.927 28.3809 33.6208 30.3212 31.9708 31.9712C30.3208 33.6212 28.3805 34.9274 26.15 35.8899C23.9194 36.8524 21.5361 37.3337 19 37.3337Z"
      fill="#212121"
    />
  </svg>
);

export const LogoutSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.75 13.75C1.3375 13.75 0.984375 13.6031 0.690625 13.3094C0.396875 13.0156 0.25 12.6625 0.25 12.25V1.75C0.25 1.3375 0.396875 0.984375 0.690625 0.690625C0.984375 0.396875 1.3375 0.25 1.75 0.25H7V1.75H1.75V12.25H7V13.75H1.75ZM10 10.75L8.96875 9.6625L10.8813 7.75H4.75V6.25H10.8813L8.96875 4.3375L10 3.25L13.75 7L10 10.75Z"
      fill="#1E1E1E"
    />
  </svg>
);

export const ForgotPasswordMailSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={111}
    height={111}
    viewBox="0 0 111 111"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={1}
      y={1}
      width={109}
      height={109}
      rx={54.5}
      stroke="#7CAAB4"
      strokeWidth={2}
    />
    <mask
      id="mask0_254_32810"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={20}
      y={20}
      width={71}
      height={71}
    >
      <rect
        x={20.8125}
        y={20.8125}
        width={69.375}
        height={69.375}
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_254_32810)">
      <path
        d="M32.375 78.625C30.7852 78.625 29.4242 78.0589 28.292 76.9268C27.1598 75.7946 26.5938 74.4336 26.5938 72.8438V38.1562C26.5938 36.5664 27.1598 35.2054 28.292 34.0732C29.4242 32.9411 30.7852 32.375 32.375 32.375H78.625C80.2148 32.375 81.5758 32.9411 82.708 34.0732C83.8402 35.2054 84.4062 36.5664 84.4062 38.1562V72.8438C84.4062 74.4336 83.8402 75.7946 82.708 76.9268C81.5758 78.0589 80.2148 78.625 78.625 78.625H32.375ZM55.5 58.3906L78.625 43.9375V38.1562L55.5 52.6094L32.375 38.1562V43.9375L55.5 58.3906Z"
        fill="#7CAAB4"
      />
    </g>
  </svg>
);

export const ModalCloseSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_393_111619"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={24}
      height={24}
    >
      <rect width={24} height={24} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_393_111619)">
      <path
        d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
        fill="#6B6B6B"
      />
    </g>
  </svg>
);

export const EditSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_749_1893"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_749_1893)">
      <path
        d="M2.25 15.75V12.5625L12.15 2.68125C12.3 2.54375 12.4656 2.4375 12.6469 2.3625C12.8281 2.2875 13.0188 2.25 13.2188 2.25C13.4187 2.25 13.6125 2.2875 13.8 2.3625C13.9875 2.4375 14.15 2.55 14.2875 2.7L15.3188 3.75C15.4688 3.8875 15.5781 4.05 15.6469 4.2375C15.7156 4.425 15.75 4.6125 15.75 4.8C15.75 5 15.7156 5.19062 15.6469 5.37187C15.5781 5.55312 15.4688 5.71875 15.3188 5.86875L5.4375 15.75H2.25ZM13.2 5.85L14.25 4.8L13.2 3.75L12.15 4.8L13.2 5.85Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const EyeSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_749_7352"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_749_7352)">
      <path
        d="M9 12C9.9375 12 10.7344 11.6719 11.3906 11.0156C12.0469 10.3594 12.375 9.5625 12.375 8.625C12.375 7.6875 12.0469 6.89062 11.3906 6.23438C10.7344 5.57812 9.9375 5.25 9 5.25C8.0625 5.25 7.26562 5.57812 6.60938 6.23438C5.95312 6.89062 5.625 7.6875 5.625 8.625C5.625 9.5625 5.95312 10.3594 6.60938 11.0156C7.26562 11.6719 8.0625 12 9 12ZM9 10.65C8.4375 10.65 7.95938 10.4531 7.56563 10.0594C7.17188 9.66563 6.975 9.1875 6.975 8.625C6.975 8.0625 7.17188 7.58437 7.56563 7.19063C7.95938 6.79688 8.4375 6.6 9 6.6C9.5625 6.6 10.0406 6.79688 10.4344 7.19063C10.8281 7.58437 11.025 8.0625 11.025 8.625C11.025 9.1875 10.8281 9.66563 10.4344 10.0594C10.0406 10.4531 9.5625 10.65 9 10.65ZM9 14.25C7.175 14.25 5.5125 13.7406 4.0125 12.7219C2.5125 11.7031 1.425 10.3375 0.75 8.625C1.425 6.9125 2.5125 5.54688 4.0125 4.52813C5.5125 3.50938 7.175 3 9 3C10.825 3 12.4875 3.50938 13.9875 4.52813C15.4875 5.54688 16.575 6.9125 17.25 8.625C16.575 10.3375 15.4875 11.7031 13.9875 12.7219C12.4875 13.7406 10.825 14.25 9 14.25Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const ClientEditSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_749_7356"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_749_7356)">
      <path
        d="M2.25 15.75V12.5625L12.15 2.68125C12.3 2.54375 12.4656 2.4375 12.6469 2.3625C12.8281 2.2875 13.0188 2.25 13.2188 2.25C13.4187 2.25 13.6125 2.2875 13.8 2.3625C13.9875 2.4375 14.15 2.55 14.2875 2.7L15.3188 3.75C15.4688 3.8875 15.5781 4.05 15.6469 4.2375C15.7156 4.425 15.75 4.6125 15.75 4.8C15.75 5 15.7156 5.19062 15.6469 5.37187C15.5781 5.55312 15.4688 5.71875 15.3188 5.86875L5.4375 15.75H2.25ZM13.2 5.85L14.25 4.8L13.2 3.75L12.15 4.8L13.2 5.85Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const ProjectAddMoreTimeSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.66245 1.57422C4.74745 1.57422 1.57495 4.74672 1.57495 8.66172C1.57495 12.5767 4.74745 15.7492 8.66245 15.7492C8.83129 15.7492 8.99653 15.7424 9.16195 15.7289C8.63203 14.966 8.32495 14.0448 8.32495 13.0492C8.32495 10.4403 10.441 8.32422 13.05 8.32422C14.0455 8.32422 14.967 8.6313 15.7296 9.16122C15.7431 8.9958 15.75 8.83056 15.75 8.66172C15.75 4.74672 12.5775 1.57422 8.66245 1.57422ZM9.33745 8.66172C9.33745 9.0345 9.03523 9.33672 8.66245 9.33672H5.62495C5.25217 9.33672 4.94995 9.0345 4.94995 8.66172C4.94995 8.28894 5.25217 7.98672 5.62495 7.98672H7.98745V4.27422C7.98745 3.90144 8.28967 3.59922 8.66245 3.59922C9.03523 3.59922 9.33745 3.90144 9.33745 4.27422V8.66172Z"
      fill="#9E9E9E"
    />
    <path
      d="M13.05 9.67578C11.1861 9.67578 9.67505 11.1869 9.67505 13.0508C9.67505 14.9147 11.1861 16.4258 13.05 16.4258C14.9139 16.4258 16.425 14.9147 16.425 13.0508C16.425 11.1869 14.9139 9.67578 13.05 9.67578ZM14.4 13.7258H13.725V14.4008C13.725 14.7736 13.4232 15.0758 13.05 15.0758C12.6769 15.0758 12.375 14.7736 12.375 14.4008V13.7258H11.7C11.3269 13.7258 11.025 13.4236 11.025 13.0508C11.025 12.678 11.3269 12.3758 11.7 12.3758H12.375V11.7008C12.375 11.328 12.6769 11.0258 13.05 11.0258C13.4232 11.0258 13.725 11.328 13.725 11.7008V12.3758H14.4C14.7732 12.3758 15.075 12.678 15.075 13.0508C15.075 13.4236 14.7732 13.7258 14.4 13.7258Z"
      fill="#9E9E9E"
    />
  </svg>
);

export const ProjectExtendTimeSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_206_24727)">
      <path
        d="M5.86875 3.12727H4.96406V2.68864C4.96406 2.44747 5.1677 2.25 5.41641 2.25C5.66511 2.25 5.86875 2.44747 5.86875 2.68864V3.12727ZM13.1062 2.68864C13.1062 2.44747 12.9026 2.25 12.6539 2.25C12.4052 2.25 12.2016 2.44747 12.2016 2.68864V3.12727H13.1062V2.68864ZM14.4633 3.12727H13.1062V3.56591C13.1062 3.80707 12.9026 4.00454 12.6539 4.00454C12.4052 4.00454 12.2016 3.80707 12.2016 3.56591V3.12727H5.86875V3.56591C5.86875 3.80707 5.66511 4.00454 5.41641 4.00454C5.1677 4.00454 4.96406 3.80707 4.96406 3.56591V3.12727H3.60703C2.86071 3.12727 2.25 3.71947 2.25 4.44318V5.75909H15.8203V4.44318C15.8203 3.71947 15.2096 3.12727 14.4633 3.12727ZM2.25 6.63636V14.0932C2.25 14.8188 2.85872 15.4091 3.60703 15.4091H14.4633C15.2116 15.4091 15.8203 14.8188 15.8203 14.0932V6.63636H2.25ZM11.2969 11.4614H9.4875V13.2159C9.4875 13.4581 9.28496 13.6545 9.03515 13.6545C8.78535 13.6545 8.58281 13.4581 8.58281 13.2159V11.4614H6.77344C6.52363 11.4614 6.32109 11.265 6.32109 11.0227C6.32109 10.7805 6.52363 10.5841 6.77344 10.5841H8.58281V8.82954C8.58281 8.58731 8.78535 8.39091 9.03515 8.39091C9.28496 8.39091 9.4875 8.58731 9.4875 8.82954V10.5841H11.2969C11.5467 10.5841 11.7492 10.7805 11.7492 11.0227C11.7492 11.265 11.5467 11.4614 11.2969 11.4614Z"
        fill="#9E9E9E"
      />
    </g>
    <defs>
      <clipPath id="clip0_206_24727">
        <rect width={18} height={18} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ProjectDeleteSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_206_24728"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_206_24728)">
      <path
        d="M5.25 15.75C4.8375 15.75 4.48438 15.6031 4.19062 15.3094C3.89687 15.0156 3.75 14.6625 3.75 14.25V4.5H3V3H6.75V2.25H11.25V3H15V4.5H14.25V14.25C14.25 14.6625 14.1031 15.0156 13.8094 15.3094C13.5156 15.6031 13.1625 15.75 12.75 15.75H5.25ZM6.75 12.75H8.25V6H6.75V12.75ZM9.75 12.75H11.25V6H9.75V12.75Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const CalendarArrowUpSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.44971 7.99984L4.38971 8.93984L8.11637 5.21984V13.3332H9.44971V5.21984L13.1697 8.9465L14.1164 7.99984L8.78304 2.6665L3.44971 7.99984Z"
      fill="black"
    />
  </svg>
);

export const CalendarArrowDownSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.1164 7.99984L13.1764 7.05984L9.44971 10.7798V2.6665H8.11637V10.7798L4.39637 7.05317L3.44971 7.99984L8.78304 13.3332L14.1164 7.99984Z"
      fill="black"
    />
  </svg>
);

export const CalendarSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_771_11816"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={18}
    >
      <rect width={18} height={18} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_771_11816)">
      <path
        d="M3.75 16.5C3.3375 16.5 2.98438 16.3531 2.69063 16.0594C2.39688 15.7656 2.25 15.4125 2.25 15V4.5C2.25 4.0875 2.39688 3.73438 2.69063 3.44063C2.98438 3.14688 3.3375 3 3.75 3H4.5V1.5H6V3H12V1.5H13.5V3H14.25C14.6625 3 15.0156 3.14688 15.3094 3.44063C15.6031 3.73438 15.75 4.0875 15.75 4.5V15C15.75 15.4125 15.6031 15.7656 15.3094 16.0594C15.0156 16.3531 14.6625 16.5 14.25 16.5H3.75ZM3.75 15H14.25V7.5H3.75V15ZM3.75 6H14.25V4.5H3.75V6ZM9 10.5C8.7875 10.5 8.60938 10.4281 8.46563 10.2844C8.32188 10.1406 8.25 9.9625 8.25 9.75C8.25 9.5375 8.32188 9.35938 8.46563 9.21563C8.60938 9.07188 8.7875 9 9 9C9.2125 9 9.39063 9.07188 9.53438 9.21563C9.67813 9.35938 9.75 9.5375 9.75 9.75C9.75 9.9625 9.67813 10.1406 9.53438 10.2844C9.39063 10.4281 9.2125 10.5 9 10.5ZM6 10.5C5.7875 10.5 5.60938 10.4281 5.46562 10.2844C5.32187 10.1406 5.25 9.9625 5.25 9.75C5.25 9.5375 5.32187 9.35938 5.46562 9.21563C5.60938 9.07188 5.7875 9 6 9C6.2125 9 6.39062 9.07188 6.53438 9.21563C6.67812 9.35938 6.75 9.5375 6.75 9.75C6.75 9.9625 6.67812 10.1406 6.53438 10.2844C6.39062 10.4281 6.2125 10.5 6 10.5ZM12 10.5C11.7875 10.5 11.6094 10.4281 11.4656 10.2844C11.3219 10.1406 11.25 9.9625 11.25 9.75C11.25 9.5375 11.3219 9.35938 11.4656 9.21563C11.6094 9.07188 11.7875 9 12 9C12.2125 9 12.3906 9.07188 12.5344 9.21563C12.6781 9.35938 12.75 9.5375 12.75 9.75C12.75 9.9625 12.6781 10.1406 12.5344 10.2844C12.3906 10.4281 12.2125 10.5 12 10.5ZM9 13.5C8.7875 13.5 8.60938 13.4281 8.46563 13.2844C8.32188 13.1406 8.25 12.9625 8.25 12.75C8.25 12.5375 8.32188 12.3594 8.46563 12.2156C8.60938 12.0719 8.7875 12 9 12C9.2125 12 9.39063 12.0719 9.53438 12.2156C9.67813 12.3594 9.75 12.5375 9.75 12.75C9.75 12.9625 9.67813 13.1406 9.53438 13.2844C9.39063 13.4281 9.2125 13.5 9 13.5ZM6 13.5C5.7875 13.5 5.60938 13.4281 5.46562 13.2844C5.32187 13.1406 5.25 12.9625 5.25 12.75C5.25 12.5375 5.32187 12.3594 5.46562 12.2156C5.60938 12.0719 5.7875 12 6 12C6.2125 12 6.39062 12.0719 6.53438 12.2156C6.67812 12.3594 6.75 12.5375 6.75 12.75C6.75 12.9625 6.67812 13.1406 6.53438 13.2844C6.39062 13.4281 6.2125 13.5 6 13.5ZM12 13.5C11.7875 13.5 11.6094 13.4281 11.4656 13.2844C11.3219 13.1406 11.25 12.9625 11.25 12.75C11.25 12.5375 11.3219 12.3594 11.4656 12.2156C11.6094 12.0719 11.7875 12 12 12C12.2125 12 12.3906 12.0719 12.5344 12.2156C12.6781 12.3594 12.75 12.5375 12.75 12.75C12.75 12.9625 12.6781 13.1406 12.5344 13.2844C12.3906 13.4281 12.2125 13.5 12 13.5Z"
        fill="#9E9E9E"
      />
    </g>
  </svg>
);

export const CheckboxCheckedSVG = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_771_8535"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={18}
        height={18}
      >
        <rect width={18} height={18} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_771_8535)">
        <path
          d="M7.95 12.15L13.2375 6.8625L12.1875 5.8125L7.95 10.05L5.8125 7.9125L4.7625 8.9625L7.95 12.15ZM3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39688 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39688 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H14.25C14.6625 2.25 15.0156 2.39688 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H3.75Z"
          fill="#181FDD"
        />
      </g>
    </svg>
  );
};

export const CheckboxUncheckedSVG = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_771_8541"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={18}
        height={18}
      >
        <rect width={18} height={18} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_771_8541)">
        <path
          d="M3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39688 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39688 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H14.25C14.6625 2.25 15.0156 2.39688 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H3.75ZM3.75 14.25H14.25V3.75H3.75V14.25Z"
          fill="#BDBDBD"
        />
      </g>
    </svg>
  );
};

export const ResendEmailSvg = ({
  color = "#6C6C6C",
  ...props
}: React.SVGProps<SVGSVGElement> & { color?: string }) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 8V5H18"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 5L15 11"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.8273 3 17.35 4.30367 19 6.34"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EmailSvg = ({
  active,
  color,
  ...props
}: React.SVGProps<SVGSVGElement> & { active?: boolean, color?: string }) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_2063_23831"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={20}
      >
        <rect width={20} height={20} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2063_23831)">
        <path
          d="M3.33366 16.6666C2.87533 16.6666 2.48296 16.5035 2.15658 16.1771C1.83019 15.8507 1.66699 15.4583 1.66699 15V4.99998C1.66699 4.54165 1.83019 4.14929 2.15658 3.8229C2.48296 3.49651 2.87533 3.33331 3.33366 3.33331H16.667C17.1253 3.33331 17.5177 3.49651 17.8441 3.8229C18.1705 4.14929 18.3337 4.54165 18.3337 4.99998V15C18.3337 15.4583 18.1705 15.8507 17.8441 16.1771C17.5177 16.5035 17.1253 16.6666 16.667 16.6666H3.33366ZM10.0003 10.8333L16.667 6.66665V4.99998L10.0003 9.16665L3.33366 4.99998V6.66665L10.0003 10.8333Z"
          fill={color ? color : active ? "#73B5C5" : "#6C6C6C"}
        />
      </g>
    </svg>
  );
};
